/* eslint-disable */
import React from 'react';
import {
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
    Datagrid,
} from 'react-admin';
import { EditToolbar } from '../layout/EditToolbar';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { SwList } from '../lib/SwList';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';

export const ModuleTypeLabels = {
    pageTitle: 'Module Types',
    Title: 'Code',
};

export const ModuleTypeList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={ModuleTypeLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField label={ModuleTypeLabels.Title} source="Title" />
                    <TextField source="description" />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const ModuleTypeEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByDescription />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput label={ModuleTypeLabels.Title} source="Title" />
                    <TextInput source="description" />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const ModuleTypeCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput label={ModuleTypeLabels.Title} source="Title" />
            <TextInput source="description" />
            <BooleanInput source="current" defaultValue={false} />
        </SimpleForm>
    </Create>
);

export const ModuleTypeShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label={ModuleTypeLabels.Title} source="Title" />
            <TextField source="description" />
            <BooleanField source="current" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
